import React from 'react';
import {getEnvironment} from '../../app/App';
import SweetAlert from 'react-bootstrap-sweetalert';
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import withAutoplay from 'react-awesome-slider/dist/autoplay';
// Icons

class Directory extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      companis: [],
      actions: [],
      searchcompanis: [],
      contacts: [],
      companies: [],
      images: [],
      allcompany: [],
      contextApp: '',
      idDirectory: 0,
      directories: [],
      showMessageWarning: false,
      showMessageError: false,
      onShowLoadingk: false,
      message: 0,
      open: true,
      show: false,
      id: 0
    }
    this.onSavePreCustomer = this.onSavePreCustomer.bind(this);
    this.onChangeNameCompany = this.onChangeNameCompany.bind(this);
    this.onChangePhone = this.onChangePhone.bind(this);
    this.onChangeNameOwner = this.onChangeNameOwner.bind(this);
    this.onChangeMunicipio = this.onChangeMunicipio.bind(this);
    this.onChangeLocation = this.onChangeLocation.bind(this);
    this.onChangeHorario = this.onChangeHorario.bind(this);
    this.searchComanies = this.searchComanies.bind(this);
    this.getAllCompanies = this.getAllCompanies.bind(this);
    this.onChangeKeyWords = this.onChangeKeyWords.bind(this);

  }


    hideMessage(){
      this.setState({showMessageWarning: false, showMessageError: false});
    }

    onConfirmUnBloc() {
      this.hideMessageWarnings();
    }

    onConfirmError(){
    this.hideMessage();
  }

    onCancelBlock(){
      this.hideMessage();
    }

    hideMessageWarnings() {
    this.setState({
      showMessageWarning: false
    });
  }

  closeWindowDefault(){
      this.setState({ onShowLoadingk: false});
  }

    clean() {
      document.getElementById("preCustomerForm").reset();
    }

    onChangeNameCompany(event){
      this.setState({ nameCompany:  event.target.value});
    }

    onChangePhone(event){
      this.setState({ phoneNumber:  event.target.value});
    }

    onChangeNameOwner(event){
      this.setState({ nameOwner:  event.target.value});
    }

    onChangeMunicipio(event){
      this.setState({ municipio:  event.target.value});
    }

    onChangeLocation(event){
      this.setState({ direction:  event.target.value});
    }

    onChangeHorario(event){
      this.setState({ schedule:  event.target.value});
    }

    onChangeKeyWords(event){
      this.setState({ keyWords:  event.target.value});
    }

    onSavePreCustomer(){

      var confCurrent = getEnvironment();
      var valido = true;
      if(this.state.nameCompany === null || this.state.nameCompany ===''){
        valido = false;
      }
      if(this.state.phoneNumber === null || this.state.phoneNumber ===''){
        valido = false;
      }
      if(this.state.nameOwner === null || this.state.nameOwner === ''){
        valido = false;
      }
      if(this.state.municipio === null || this.state.municipio === ''){
        valido = false;
      }
      if(this.state.direction === null || this.state.direction === ''){
        valido = false;
      }
      if(this.state.schedule === null || this.state.schedule === ''){
        valido = false;
      }
      if(valido){
        const axios = require('axios');
        var datos = new FormData();
        datos.append("name_company", this.state.nameCompany);
        datos.append("phone_number", this.state.phoneNumber);
        datos.append("name_owner", this.state.nameOwner);
        datos.append("municipio", this.state.municipio);
        datos.append("direction", this.state.direction);
        datos.append("schedule", this.state.schedule);

        let that = this;
        axios.post(confCurrent.home +'a/save/pre/customer/' + Date.now(), datos)
        .then(function (response) {
          console.log(response);
          if(response.data.success === 'true' || response.data.success === true){
            console.log('preCustomer agregado');
            that.clean();
            that.setState({
              showMessageWarning: true,
              showMessageError: false
            });
          }else{
            console.log('user no  agregado');
            that.setState({
              showMessageWarning: false,
              showMessageError: true
            });
          }
        })
        .catch(function (error) {
          console.log('ha ocurrido un error');
          that.setState({showMessageWarning: false,showMessageError: true});
      });
      }else{
        console.log('llena todos los campos');
        this.setState({showMessageWarning: false,showMessageError: true});
    }
    }


  componentDidMount(){
    this.setState({idDirectory: window.sessionDirectory.idDirectory}, this.callData);
    this.setState({idCompany: window.sessionCompany.idCompany}, this.callData);
    this.setState({ onShowLoadingk: true});
  }

  callData = () =>{
    this.getDirectories();
    this.getActions();
    this.getCompany();
    this.getImages();
    this.getContact();
    this.getCompanies();
    this.getPhoneCall();
    this.getResultsSearch();
  }


    searchComanies(){
        console.log('----------- buscando -------------');
        var valido = true;
        if(this.state.keyWords === null || this.state.keyWords === ''){
            let that = this;
            valido = false;
            that.setState({message: 2});
        }

        if(valido === true){
            const axios = require('axios');
            var datos = new FormData();
            datos.append("idDirectory", this.state.idDirectory);
            datos.append("key_words", this.state.keyWords);

            let that = this;
            var confCurrent = getEnvironment(this.state.idDirectory);
            axios.post(confCurrent.home + 'a/get/by/keyword/' + Date.now(), datos)
            .then(function (response) {
                console.log("---- resultado del search -----: ",response);
                if(response.data.data.SearchCompani != null && response.data.data.SearchCompani !== ''){
                    that.setState({searchcompanis: response.data.data.SearchCompani, message: 1});
                    console.log(" message despues : " , that.state.message);
                } else{
                    that.setState({searchcompanis: []});
                }
            })
            .catch(function (error) {
                console.log(error);
            });

        } else {
            console.log('no busques vacio');
        }
    }


    getAllCompanies() {
      const axios = require('axios');
      var datos = new FormData();
      datos.append("idDirectory", this.state.idDirectory);
      console.log("idDir: ", this.state.idDirectory);
      let that = this;
      var confCurrent = getEnvironment(this.state.idDirectory);
      axios.post(confCurrent.home + 'a/company/all/search/' + Date.now(), datos)
      .then(function (response) {
        console.log("AllCompany: ",response);
        if(response.data.data.AllCompany != null && response.data.data.AllCompany !== ''){
          that.setState({allcompany: response.data.data.AllCompany,  message: 2, searchcompanis: []});
          console.log(" message all despues : " , that.state.message);
        }else{
          that.setState({allcompany: []});
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    }



  getCompanies(){
    console.log('consultando lista');
    const axios = require('axios');
    var datos = new FormData();
    let that = this;
    var confCurrent = getEnvironment(this.state.idDirectory);
    axios.post(confCurrent.home +'a/list/get/' + Date.now(), datos)
    .then(function (response) {
      //console.log("lista",response);
      if(response.data.data.Directories != null && response.data.data.Directories !== ''){
        that.setState({directories: response.data.data.Directories, loading: false});
      }else{
        that.setState({directories: [], loading: false});
      }

    })
    .catch(function (error) {
      console.log(error);
    });
  }


  getDirectories () {
    const axios = require('axios');
    var datos = new FormData();
    datos.append("idDirectory", this.state.idDirectory);
    datos.append("idCompany", this.state.idCompany);
    let that = this;
    var confCurrent = getEnvironment(this.state.idDirectory);
    axios.post(confCurrent.home + 'a/directory/get/' + Date.now(), datos)
    .then(function (response) {
        //console.log("companiiiiii: ",response);
      if(response.data.data.Companis != null && response.data.data.Companis !== ''){
        that.setState({companis: response.data.data.Companis, loading: false});
      }else{
        that.setState({companis: [], loading: false});
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }



  getActions() {
    const axios = require('axios');
    var datos = new FormData();
    datos.append("idDirectory", this.state.idDirectory);
    datos.append("idCompany", this.state.idCompany);
    let that = this;
    var confCurrent = getEnvironment(this.state.idDirectory);
    axios.post(confCurrent.home + 'a/actions/get/' + Date.now(), datos)
    .then(function (response) {
      console.log("Actions", response);
      if(response.data.data.Actions != null && response.data.data.Actions !== '') {
        that.setState({actions: response.data.data.Actions, loading: false});
      }else{
        that.setState({actions: [], loading: false});
      }
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  getContact() {
      const axios = require('axios');
      var datos = new FormData();
      datos.append("idDirectory", this.state.idDirectory);
      datos.append("idCompany", this.state.idCompany);
      let that = this;
      var confCurrent = getEnvironment(this.state.idDirectory);
      axios.post(confCurrent.home + 'a/contacts/get/' + Date.now(), datos)
      .then(function (response) {
        if(response.data.data.Contacts != null && response.data.data.Contacts !== ''){
          that.setState({contacts: response.data.data.Contacts, loading: false});
        }else{
          that.setState({contacts: [], loading: false});
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    }

    getImages() {
      const axios = require('axios');
      var datos = new FormData();
      datos.append("idDirectory", this.state.idDirectory);
      datos.append("idCompany", this.state.idCompany);
      let that = this;
      var confCurrent = getEnvironment(this.state.idDirectory);
      axios.post(confCurrent.home +'a/company/getimages/' + Date.now(), datos)
      .then(function (response) {
        if(response.data.data.Images != null && response.data.data.Images !== '') {
          that.setState({images: response.data.data.Images, loading: false});
          //console.log("response images ",response);
        }else{
          that.setState({images: [], loading: false});
        }

      })
      .catch(function (error) {
        console.log(error);
      });
    }

   getCompany() {
      const axios = require('axios');
      var datos = new FormData();
      datos.append("idDirectory", this.state.idDirectory);
      datos.append("idCompany", this.state.idCompany);
      let that = this;
      var confCurrent = getEnvironment(this.state.idDirectory);
      axios.post(confCurrent.home + 'a/company/get/' + Date.now(), datos)
      .then(function (response) {
        if(response.data.data.Companies != null && response.data.data.Companies !== ''){
          that.setState({companies: response.data.data.Companies, loading: false});
        }else{
          that.setState({companies: [], loading: false});
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    }

    getActionsByDirectory(idCompany,logoBusiness) {
      const actionsDirectory = [];
      for (var x=0;x < this.state.actions.length;x++){
          let action = this.state.actions[x];
          if (action.idCompany.idCompany === idCompany) {
              let confCurrent = getEnvironment(this.state.idDirectory);
              let icon = 'check.png';
              let tg = "_blank";
              let url;

              if (action.subType == 1) {

                if (action.idStatus == 1) {
                  if (action.description === '' || action.description === null) {
                    icon = 'nocheck.png';
                  }
                } else if (action.idStatus == 2) {
                    icon = 'nocheck.png';
                }

                  const url = action.urlIcon;
                  const string1 = "door";
                  const string2 = "moto";
                  const string3 = "rapidiux";

                  if ( (url.includes(string1)) ||  (url.includes(string2)) || (url.includes(string3)) ) {

                    actionsDirectory.push(
                        <div key={action.idAction} className="col-6 col-sm-6 col-md-6 col-lg-6 pb-1 text-left">
                          <p className="float-left text-left directory-text">
                            <img className="icon" src = {confCurrent.home + 'assets/images/' + action.urlIcon + icon} alt=""/>
                            <small> {action.description} </small>
                          </p>
                        </div>);

                  } else {
                      actionsDirectory.push(
                           <div className="col-12 col-sm-12 col-md-12 col-lg-12 pb-1 text-left">
                             <p className="float-left text-left directory-text">
                               <img className="icon" src = {confCurrent.home + 'assets/images/' + action.urlIcon + icon} alt=""/>
                               <small> {action.description} </small>
                             </p>
                           </div>);
                  }

              } else if (action.subType == 2) {

                  if (action.description  === '' || (action.urlRedirect === null || action.urlRedirect === '#')) {
                      icon = 'nocheck.png';
                      tg = "_self";
                      url = action.urlRedirect;
                  }   else {
                       url = action.urlRedirect + action.idCompany.latitude + ',' + action.idCompany.longitude + ',20z';
                  }

                  actionsDirectory.push(
                       <div className="col-12 col-sm-12 col-md-12 col-lg-12 pb-1 text-left">
                          <p className="float-left directory-text">
                          <a href={url} target={tg}>
                            <img  className="icon" src={confCurrent.home + "assets/images/" + action.urlIcon + icon}  alt=""/> <small> {action.description}</small>
                          </a>
                          </p>
                        </div>);

                } else if (action.subType == 3) {
                    actionsDirectory.push(
                      <div className="col-12 col-sm-12 col-md-12 col-lg-12 pb-1 text-left">
                         <p className="float-left directory-text">
                           <a href={confCurrent.home + "assets/images/" + logoBusiness + "card.jpg"} data-lightbox={'roadtrip_' + idCompany} data-title="">
                             <img  className="icon" src={confCurrent.home + "assets/images/" +action.urlIcon + icon}  alt=""/> <small> {action.description}</small>
                           </a>
                         </p>
                       </div>);

                  } else if (action.subType == 4) {
                      url = action.urlRedirect;
                      actionsDirectory.push(
                       <div className="col-12 col-sm-12 col-md-12 col-lg-12 pb-1 text-left">
                          <p className="float-left directory-text">
                          <a href={url}>
                            <img  className="icon" src={confCurrent.home + "assets/images/" + action.urlIcon + icon}  alt=""/> <small> {action.description}</small>
                          </a>
                          </p>
                        </div>);

                  }  else if (action.subType == 5) {
                      url = action.urlRedirect;
                      actionsDirectory.push(
                       <div className="col-12 col-sm-12 col-md-12 col-lg-12 pb-1 text-left">
                          <p className="float-left directory-text">
                          <a href={url}>
                            <img  className="icon" src={confCurrent.home + "assets/images/" + action.urlIcon + icon}  alt=""/> <small> {action.description}</small>
                          </a>
                          </p>
                        </div>);
                  }
          }
      }

      return actionsDirectory;
    }



    getContactsByDirectory(idCompany){
        const s = {width: '27px' , height: '27px'};
        const contactsDirectory = [];
        for (var x=0;x < this.state.contacts.length;x++){
         const contact = this.state.contacts[x];
         if (contact.idCompany === idCompany) {
           var confCurrent = getEnvironment(this.state.idDirectory);
           var icon = 'check.png';
           var tg = "_blank";
           if (contact.urlRedirect === '#' || contact.urlRedirect === '') {
                icon = 'nocheck.png';
                tg = "_self";
           }

          contactsDirectory.push(
               <div  className="col-4 col-sm-4 col-md-4">
                 <a href={contact.urlRedirect} target={tg}>
                   <span><img  className="icon" src={confCurrent.home + "assets/images/" + contact.urlIcon + icon}  className="mx-auto d-block" style={s} alt=""/></span>
                 </a>
               </div>
           );
         }
       }

       return contactsDirectory;
     }



    getImagesByDirectory(idCompany) {
        // menu
        const imagesD = [];
        var confCurrent = getEnvironment(this.state.idDirectory);
        let that = this;
        for(var x=0;x < this.state.images.length;x++){
            const action = this.state.images[x];
            if(action.idCompany === idCompany) {
                var urlImage = action.url + '?t=' + Date.now();
                imagesD.push(<a key={action.idAction} href= { confCurrent.home + "assets/images/" + urlImage} data-lightbox= {'roadtrip_' + idCompany} ></a>);
            }
        }

      return imagesD;
  }


    getPhoneCall(idCompany) {
        const s = {width: '25px' , height: '25px'};
        let that = this;
        const phoneInfo = [];
        var confCurrent = getEnvironment(this.state.idDirectory);
        var idCompani = window.sessionCompany.idCompany;
        for(var x=0;x < this.state.actions.length;x++){
            const call = this.state.actions[x];
            if(call.idCompany.idCompany === idCompany) {
                if (idCompani == 0){
                    if (call.subType == 4){
                       phoneInfo.push(
                           <a key={call.idCompany.idCompany} className="txt-card-call float-right"href={call.urlRedirect} >
                             <img src={confCurrent.home + "assets/images/icons/call_icon_phone.png"}  className=""  alt="" style={s}/>&nbsp;
                             Llamar
                           </a>
                        );
                   }
               } else {
                   if (call.subType == 4){
                      phoneInfo.push(
                          <a key={call.idCompany.idCompany} className="txt-card-call"href={call.urlRedirect} >
                            <img src={confCurrent.home + "assets/images/icons/call_icon_phone.png"}  className=""  alt="" style={s}/>&nbsp;
                            Llamar
                          </a>
                       );
                  }
               }
            }
        }

        return phoneInfo;

    }


    getResultsSearch(idCompany){
      const bus = [];
      var confCurrent = getEnvironment(this.state.idDirectory);
      for(var s=0;s < this.state.searchcompanis.length;s++){
          const searchC = this.state.searchcompanis[s];
          console.log("iddd search: " ,searchC.idCompany )
          if(searchC.idCompany === idCompany) {
            const s = {width: '25px' , height: '25px'};
            bus.push(
                 <a className="txt-card-call float-right"href={searchC.urlRedirect} >
                   <img src={confCurrent.home + "assets/images/icons/call_icon_phone.png"}  className=""  alt="" style={s}/>&nbsp;
                   Llamar
                 </a>
            );
          }
      }

      return bus;
    }


    getPhone2Call(idCompany) {
        const phoneInfo = [];
        var confCurrent = getEnvironment(this.state.idDirectory);
        var idCompani = window.sessionCompany.idCompany;
        for(var x=0;x < this.state.actions.length;x++){
            const call = this.state.actions[x];
            if(call.idCompany.idCompany === idCompany) {
                const s = {width: '25px' , height: '25px'};
                if (idCompani == 0){
                    if (call.subType == 4){
                       phoneInfo.push(
                           <a className="txt-card-call float-right"href={call.urlRedirect} >
                             <img src={confCurrent.home + "assets/images/icons/call_icon_phone.png"}  className=""  alt="" style={s}/>&nbsp;
                             Llamar
                           </a>
                        );
                   }
               } else {
                   if (call.subType == 4){
                      phoneInfo.push(
                          <a className="txt-card-call"href={call.urlRedirect} >
                            <img src={confCurrent.home + "assets/images/icons/call_icon_phone.png"}  className=""  alt="" style={s}/>&nbsp;
                            Llamar
                          </a>
                       );
                  }
               }
            }
        }

        return phoneInfo;
    }



    toggleImage (compani) {
        console.log("--------- change el icon ---------");
        console.log("idCompany: ", compani.idCompany);    // 1

    }


  render() {

    const s = {width: '30px' , height: '30px'};
    const c = {width: '25px' , height: '25px'};
    var confCurrent = getEnvironment(this.state.idDirectory);
    const contentsearch = [];
    var idCompani = window.sessionCompany.idCompany;
    var idDirectori = window.sessionDirectory.idDirectory;
        if (idCompani == 0){
            contentsearch.push(

                <div className="container content-search">
                    <div className="full-search-2 italian-search hero-search-radius">
                      <div className="hero-search-content">
                          <div className="row">
                              <div className="col-lg-8 col-md-7 col-sm-6 small-padd">
                                  <div className="form-group fg-search">
                                   <form id="searchForKeyWord">
                                      <div className="input-with-icon">
                                        <input type="text" className="form-control b-r" name="key_words" id="keyWords"  onChange={this.onChangeKeyWords} placeholder="¿Que deseas encontrar?" />
                                      </div>
                                    </form>
                                  </div>
                              </div>
                             <div className="col-lg-4 col-md-5 col-sm-6">
                               <div className="form-group pd-search">
                                 <div className="form-group">
                                   <button type="button" className="btn btn-sch" onClick={this.searchComanies} method="post" >Buscar</button>

                                   <button type="button" className="btn btn-all float-right" onClick={this.getAllCompanies} method="post" >Ver todo</button>
                                 </div>
                               </div>
                             </div>
                          </div>
                      </div>
                    </div>
                 </div>
            );

        }


        const mapLocation = [];
        var idDirectori = window.sessionDirectory.idDirectory;
            if (idCompani == 0){
                mapLocation.push(
                    <div className="container content-search">
                         <div className="row">
                             <div className="col-lg-4 col-md-3 "></div>
                             <div className="col-lg-4 col-md-6 col-sm-12 pd-map">
                                 <a  href={"https://rapidiux.com/"} className="text-center txt-regreso">
                                     <img src={confCurrent.home + "assets/images/ico/location.png"} alt="home"  className="img-home" style={s}/>&nbsp; Ver mapa
                                 </a>
                             </div>
                              <div className="col-lg-4 col-md-3"></div>
                        </div>
                     </div>
                );

            }



    const linklocation = [];
    if (idCompani > 0){
        for(var x=0;x < this.state.companis.length;x++) {
        const municipio = this.state.companis[x];
        const a = {width: '25px' , height: '25px'};
            linklocation.push(
                <div className="container "><br></br>
                    <div className="row pd-txt">
                        <div className="col-lg-4 col-md-2 col-sm-1"></div>
                        <div className="col-lg-4 col-md-6 col-sm-10">
                            <a  href={"https://rapidiux.com/" + municipio.token} className="text-center txt-regreso">
                                <img src={confCurrent.home + "assets/images/icons/ico_business_home.png"} alt="home"  className="img-home" style={a}/>&nbsp;{"Ver directorio de " + municipio.name}
                            </a>
                        </div>
                        <div className="col-lg-4 col-md-2 col-sm-1"></div>
                    </div>
                 </div>
            );
        }
    }


    const sliders = [];
    var idDirectori = window.sessionDirectory.idDirectory;
    var idCompani = window.sessionCompany.idCompany;

    for(var x=0;x < this.state.companies.length;x++) {
      const com = this.state.companies[x];
      const AutoplaySlider  = withAutoplay(AwesomeSlider);
        if (idCompani > 0){
            sliders.push(
            <div className="image-cover hero-banner wd-img-company" style={{backgroundImage: "url("+confCurrent.home + "assets/images/" + com.imgBody+")"}} data-overlay="6">
              <div className="container">
                 <h1 className="big-header-capt capti text-img">{com.textBody}</h1>
              </div>
            </div>
        );
        } else {
            if (idDirectori != null){
                sliders.push(
                    <div key={com.idCompany} className="image-cover hero-banner" data-overlay="2">
                            <AutoplaySlider animation="cubeAnimation"
                                play={true}
                                cancelOnInteraction={false}
                                interval={5000}>
                              <div data-src={confCurrent.home + "assets/images/directory/" + idDirectori + "/headers/slider_1.png"} />
                              <div data-src={confCurrent.home + "assets/images/directory/" + idDirectori + "/headers/slider_2.png"} />
                              <div data-src={confCurrent.home + "assets/images/directory/" + idDirectori + "/headers/slider_3.png"} />
                              <div data-src={confCurrent.home + "assets/images/directory/" + idDirectori + "/headers/slider_4.png"} />
                              <div data-src={confCurrent.home + "assets/images/directory/" + idDirectori + "/headers/slider_5.png"} />
                            </AutoplaySlider>
                    </div>
                );
            }
        }
    }


    const itemsCompanies = [];
    for(var x=0;x < this.state.companies.length;x++) {
      const company = this.state.companies[x];
      itemsCompanies.push(
          <React.Fragment>
                <nav className="navbar navbar-expand-lg navbar-light border-list nav-hide-desk">
                    <a href="https://rapidiux.com">
                        <img className="pd-nav logo-rap" src={confCurrent.home + "assets/images/directory/header_logo.png"} alt="logo rapidiux"/>
                    </a>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav">
                            <li className="pd-social">
                                <a href="https://rapidiux.com/facebook" target="_self">
                                    <img src={confCurrent.home + "assets/images/icons/ico_fb_check.png"}  className="mx-auto"  alt="" style={s}/>
                                </a>
                            </li><a href="https://rapidiux.com/facebook" className="tx-redirect">/rapidiux</a>
                            <li className=" pd-social">
                                <a href="https://rapidiux.com/7341589302" target="_self">
                                    <span><img src={confCurrent.home + "assets/images/icons/ico_whats_check.png"}  className="mx-auto"  alt="" style={s}/>  </span>
                                </a>
                            </li><a href="https://rapidiux.com/7341589302" className="tx-redirect">734 158 9302</a>
                        </ul>
                        <ul className="">
                            <button type="button" className="btn btn-primary txt-btn btn-add" data-toggle="modal" data-target="#login">Inscribe tu negocio</button>
                        </ul>
                    </div>
                </nav>

                <nav className="navbar navbar-expand-lg navbar-light nav-hide-phone">
                    <a href="https://rapidiux.com">
                        <img className="pd-nav logo-rap" src={confCurrent.home + "assets/images/directory/header_logo.png"} />
                    </a>
                   <button className="navbar-toggler btn-hide" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                     <span className="navbar-toggler-icon"></span>
                   </button>
                   <div className="collapse navbar-collapse" id="navbarNav">
                            <ul className="navbar-nav nav-pd">
                            {this.state.directories.map(function(directory) {
                            return (
                                <li className="nav-item active company-menu">
                                    <a className="nav-link" href={"https://rapidiux.com/" + directory.token}>{directory.name}</a>
                                </li>
                            )
                            })}
                        </ul>
                   </div>
                 </nav>

                 <div className="container ctn-responsive">
                   <div className="row">
                     <div className="col-md-4 col-sm-4 cl-aling">
                       <a href="https://rapidiux.com/facebook" target="_self">
                           <img src={confCurrent.home + "assets/images/icons/ico_fb_check.png"}  className="mx-auto d-block img-social"  alt=""/> <p className="txt-social"> /rapidiux</p>
                       </a>
                     </div>
                     <div className="col-md-4 col-sm-4 cl-aling">
                       <a href="https://rapidiux.com/7341589302" target="_self">
                           <img src={confCurrent.home + "assets/images/icons/ico_whats_check.png"}  className="mx-auto d-block img-social"  alt=""/><p className="txt-social">734 158 9302</p>
                       </a>
                     </div>
                     <div className="col-md-4 col-sm-4">
                        <button type="button" className="btn btn-primary txt-btn btn-add" data-toggle="modal" data-target="#login">Inscribe tu negocio</button>
                     </div>
                   </div>
                 </div>


                 <div className="hide-directoris">
                    <div className="row pd-row">
                        {this.state.directories.map(function(directory) {
                            return (
                              <div className="nav-item active">
                                <a className="nav-link" href={"https://" + "rapidiux.com/" + directory.token}>{directory.name}</a>
                              </div>
                            )
                        })}
                    </div>
                  </div>

                  {sliders}
                  {mapLocation}
                  {contentsearch}
                  {linklocation}

                    <div className="modal2 fade" id="login" tabIndex="-1" role="dialog" aria-labelledby="registermodal">
                        <div className="modal-dialog modal-dialog-centered login-pop-form" role="document">
                          <div className="modal-content" id="registermodal" >
                            <span className="mod-close" data-dismiss="modal">X</span>
                            <img className="lg-card" src={confCurrent.home + "assets/images/directory/logo_modal.png"} alt="logo rapidiux"/>
                            <div className="modal-body">
                              <h4 className="modal-header-title text-center">! Inscribete <span className="theme-cl">es gratis !</span></h4>
                                <div className="login-form">
                                  <form id="preCustomerForm">
                                    <div className="fm-input">
                                      <p className="float-left txt-bl ft-input">Nombre del negocio</p>
                                      <div className="input-with-icon">
                                        <input type="text" onChange={this.onChangeNameCompany} className="form-control" name="name_company" id="nameCompany"/>
                                       </div>
                                    </div>
                                    <div className="fm-input">
                                      <p className="float-left txt-bl ft-input">Teléfono(s) y WhatsApp</p>
                                      <div className="input-with-icon">
                                          <input type="text" onChange={this.onChangePhone} className="form-control" name="phone_number" id="phoneNumber"/>
                                      </div>
                                    </div>
                                    <div className="fm-input">
                                      <p className="float-left txt-bl ft-input">Nombre del propietario</p>
                                      <div className="input-with-icon">
                                          <input type="text" onChange={this.onChangeNameOwner} className="form-control" name="name_owner" id="nameOwner"/>
                                      </div>
                                    </div>
                                    <div className="fm-input">
                                      <p className="float-left txt-bl ft-input">Municipio</p>
                                      <div className="input-with-icon">
                                          <input type="text" onChange={this.onChangeMunicipio} className="form-control" name="municipio" id="municipio"/>
                                      </div>
                                    </div>
                                    <div className="fm-input">
                                      <p className="float-left txt-bl ft-input">Dirección</p>
                                      <div className="input-with-icon">
                                          <input type="text" onChange={this.onChangeLocation} className="form-control" name="direction" id="direction"/>
                                      </div>
                                    </div>
                                    <div className="fm-input">
                                      <p className="float-left txt-bl ft-input">Horario</p>
                                      <div className="input-with-icon">
                                          <input type="text" onChange={this.onChangeHorario} className="form-control" name="schedule" id="schedule" placeholder="Indicar días y horario"/>
                                      </div>
                                    </div>
                                    <div className="form-group">
                                      <button type="button" onClick={this.onSavePreCustomer} className="btn btn-md full-width pop-login">Enviar</button>
                                    </div>
                                  </form>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
            </React.Fragment>

      );
    }


    const itemsDirectories = [];
    let that = this;
    var idCompani = window.sessionCompany.idCompany;
    if (that.state.searchcompanis.length > 0) { // todo esto es para la busqueda
        console.log(" ---- de busqueda -----");
        for(var d=0;d < this.state.searchcompanis.length;d++){
            const compani = this.state.searchcompanis[d];
            var idCompani = window.sessionCompany.idCompany;
            if (compani.showNameCard == 1){ // 1 -> trae imagen en la card
                itemsDirectories.push( // todas las cards | en municipio
                  <div className="col-lg-4 col-md-6 col-sm-12" key={compani.idCompany}>
                      <div  className="property_item classical-list">
                          <div  className="image sx border-card">
                              <a className="text-center" href={"https://rapidiux.com/" + compani.token +"/"+ compani.shortNameCompany}>
                                <img src={confCurrent.home + "assets/images/" + compani.logoBusiness + 'card.jpg'} alt="Card rapidiux"  className="img-responsive" />
                              </a>
                          </div>
                          <div  className="pd-btn pb-2 sx">
                            <a className="txt-menu collapsed" data-toggle="collapse" data-target={"#collapse" + compani.idCompany}  id={"ac" + compani.idCompany} aria-expanded="false" aria-controls="collapseExample">
                                Ver menú <i className="fas fa-chevron-down"></i>
                            </a>
                            {this.getPhoneCall(compani.idCompany)}
                          </div>
                          <div  className="collapse pd-bd-card in" id={"collapse" + compani.idCompany}>
                               <div  className="row border-card">
                                   {this.getActionsByDirectory(compani.idCompany,compani.logoBusiness)}
                               </div>
                               <div  className="pd-card">
                                   <div  className="row">
                                       {this.getContactsByDirectory(compani.idCompany)}
                                   </div>
                               </div>
                                {this.getImagesByDirectory(compani.idCompany)}
                           </div>
                      </div>
                  </div>
                );

            } else { // 0 -> no trae imagen en la card
                itemsDirectories.push( // todas las cards | en municipio
                  <div className="col-lg-4 col-md-6 col-sm-12" key={compani.idCompany}>
                      <div  className="property_item classical-list">
                          <div  className="image sx border-card wd-img-txt">
                              <a className="text-center" href={"https://rapidiux.com/" + compani.token +"/"+ compani.shortNameCompany}>
                                  <div className="col-12 text-center">
                                      <h2>{compani.nameBusiness}</h2>
                                  </ div>
                              </a>
                          </div>
                          <div  className="pd-btn pb-2 sx">
                            <a className="txt-menu collapsed" data-toggle="collapse" data-target={"#collapse" + compani.idCompany}  id={"ac" + compani.idCompany} aria-expanded="false" aria-controls="collapseExample">
                                Ver menú <i className="fas fa-chevron-down"></i>
                            </a>
                            {this.getPhoneCall(compani.idCompany)}
                          </div>
                          <div  className="collapse pd-bd-card in" id={"collapse" + compani.idCompany}>
                               <div  className="row border-card">
                                   {this.getActionsByDirectory(compani.idCompany,compani.logoBusiness)}
                               </div>
                               <div  className="pd-card">
                                   <div  className="row">
                                       {this.getContactsByDirectory(compani.idCompany)}
                                   </div>
                               </div>
                                {this.getImagesByDirectory(compani.idCompany)}
                           </div>
                      </div>
                  </div>
                );
            }
        }

    }  else if (that.state.message === 1) { // cuando no encuentra negocios
        console.log("heeey entra: ", that.state.message);
          itemsDirectories.push(
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <p className="txt-no-search">Aún no tenemos negocios en esta categoría :(</p>
                    </div>
                </div>
            </div>
          );

    } else if (that.state.searchcompanis.length === 0 ||  that.state.message === 2) {
        for(var x=0;x < this.state.companis.length;x++) { // datos que trae de default
          const compani = this.state.companis[x];
          if (compani.showNameCard == 1){ // 1 = si trae la imgen de la card | 0 no trae la imagen y se pone su nombre
              if ( idCompani > 0){ // cuando es solo una card
                  itemsDirectories.push(
                    <div  className="col-lg-4 col-md-6 col-sm-12" key={compani.idCompany}>
                      <div  className="property_item classical-list">
                        <div  className="image sx border-card">
                          <img src={confCurrent.home + "assets/images/" + compani.logoBusiness + 'card.jpg'} alt="Card Rapidiux"  className="img-responsive" />
                        </div>
                        <div  className="proerty_content pt-2">
                          <div  className=" pb-2 sx">
                            <h3  className="captlize">{compani.nameBusiness}</h3>
                            {this.getPhoneCall(compani.idCompany)}
                          </div>
                          <div  className="row">
                              {this.getActionsByDirectory(compani.idCompany,compani.logoBusiness)}
                          </div>
                        </div>
                        <div  className="listing-footer-info pd-social-ico">
                          <div  className="listing-cat pt-1">
                            <div  className="row">
                              {this.getContactsByDirectory(compani.idCompany)}
                            </div>
                          </div>
                        </div>
                          {this.getImagesByDirectory(compani.idCompany)}
                      </div>
                    </div>
                  );

              } else { // todas las cards | en municipio
                  itemsDirectories.push(
                    <div className="col-lg-4 col-md-6 col-sm-12" key={compani.idCompany}>
                        <div  className="property_item classical-list">
                            <a className="text-center" href={"https://rapidiux.com/" + compani.token +"/"+ compani.shortNameCompany}>
                                <div  className="image sx border-card">
                                    <img src={confCurrent.home + "assets/images/" + compani.logoBusiness + 'card.jpg'} alt="Card rapidiux"  className="img-responsive" />
                                </div>
                            </a>
                            <div  className="pd-btn pb-2 sx">
                                <a className="txt-menu collapsed" data-toggle="collapse" data-target={"#collapse" + compani.idCompany}  id={"ac" + compani.idCompany} aria-expanded="false" aria-controls="collapseExample">
                                    Ver menú <i className="fas fa-chevron-down"></i>
                                </a>
                                {this.getPhoneCall(compani.idCompany)}
                            </div>
                            <div  className="collapse pd-bd-card in" id={"collapse" + compani.idCompany}>
                                 <div  className="row border-card">
                                     {this.getActionsByDirectory(compani.idCompany,compani.logoBusiness)}
                                 </div>
                                 <div  className="pd-card">
                                     <div  className="row">
                                         {this.getContactsByDirectory(compani.idCompany)}
                                     </div>
                                 </div>
                                  {this.getImagesByDirectory(compani.idCompany)}
                             </div>
                        </div>
                    </div>
                  );
              }

          } else { // 0 - no trae la imagen y se pone su nombre
              if ( idCompani > 0) { // cuando es solo una card
                  itemsDirectories.push(
                    <div  className="col-lg-4 col-md-6 col-sm-12" key={compani.idCompany}>
                      <div  className="property_item classical-list">
                        <div  className="image sx border-card wd-img-txt">
                          <div className="col-12 text-center ">
                              <h2>{compani.nameBusiness}</h2>
                          </ div>
                        </div>
                        <div  className="proerty_content pt-2">
                          <div  className=" pb-2 sx">
                            {this.getPhoneCall(compani.idCompany)}
                          </div>
                          <div  className="row">
                              {this.getActionsByDirectory(compani.idCompany,compani.logoBusiness)}
                          </div>
                        </div>
                        <div  className="listing-footer-info pd-social-ico">
                          <div  className="listing-cat pt-1">
                            <div  className="row">
                              {this.getContactsByDirectory(compani.idCompany)}
                            </div>
                          </div>
                        </div>
                          {this.getImagesByDirectory(compani.idCompany)}
                      </div>
                    </div>
                  );
              } else { // todas las cards | en municipio
                  itemsDirectories.push(
                    <div className="col-lg-4 col-md-6 col-sm-12" key={compani.idCompany}>
                        <div  className="property_item classical-list">
                            <a className="text-center" href={"https://rapidiux.com/" + compani.token +"/"+ compani.shortNameCompany}>
                                <div  className="image sx border-card wd-img-txt" >
                                        <div className="col-12 text-center">
                                            <h2>{compani.nameBusiness}</h2>
                                        </ div>
                                </div>
                            </a>
                            <div  className="pd-btn pb-2 sx">
                                <a className="txt-menu collapsed" data-toggle="collapse" data-target={"#collapse" + compani.idCompany}  id={"ac" + compani.idCompany} aria-expanded="false" aria-controls="collapseExample">
                                    Ver menú <i className="fas fa-chevron-down"></i>
                                </a>
                                {this.getPhoneCall(compani.idCompany)}
                            </div>
                            <div  className="collapse pd-bd-card in" id={"collapse" + compani.idCompany}>
                                 <div  className="row border-card">
                                     {this.getActionsByDirectory(compani.idCompany,compani.logoBusiness)}
                                 </div>
                                 <div  className="pd-card">
                                     <div  className="row">
                                         {this.getContactsByDirectory(compani.idCompany)}
                                     </div>
                                 </div>
                                  {this.getImagesByDirectory(compani.idCompany)}
                             </div>
                        </div>
                    </div>
                  );
              }
          }
      }
  }

    var dclass = '';
    var idMenu = window.sessionMenu.idMenu;
    if(idMenu > 0 ){
        dclass = 'd-section';
    }

    return (
        <React.Fragment>
          {itemsCompanies}
          <section className={dclass}>
            <div  className="container pd-container">
              <div  className="tab-content">
                <div  className="tab-pane fade in show active" id="rapida" role="tabpanel">
                  <div  className="row">
                    {itemsDirectories}
                  </div>
                </div>
              </div>
            </div>
          </section>

          <footer className={"dark-footer skin-dark-footer " + dclass}>
              <div className="footer-bottom">
                  <div className="container">
                      <div className="row align-items-center">
                          <div className="col-lg-12 col-md-12 text-center">
                            <p className="mb-0 txt-footer">© 2020 Rapidiux. Design By <a className="txt-sof" href="https://softiux.com">SoftiUX</a> All Rights Reserved</p>
                          </div>
                      </div>
                  </div>
              </div>
          </footer>

          <SweetAlert warning title="Datos enviados" onConfirm={() => this.onConfirmUnBloc()} show={this.state.showMessageWarning}>
            Sus datos han sido enviados. Uno de nuestros representantes le hara una llamada telefónica.
          </SweetAlert>

          <SweetAlert error title="Error" onConfirm={() => this.onConfirmError()} show={this.state.showMessageError}>
            Hubo un error al guardar el cliente
          </SweetAlert>


        </React.Fragment>



    );
  }
}

export default Directory;
